import { atom } from '@reatom/framework'

import { selectedNetworkAtom } from '@root/entities/network'
import { WalletId } from '@root/entities/wallet'
import { tradingWalletIdAtom } from '@root/features/trade/trading'
import { reatomUserTransactions } from '@root/features/user/transaction-history'

import type { UserTransactionsModel } from '@root/features/user/transaction-history'

let walletCache:
  | { walletId: WalletId; model: UserTransactionsModel }
  | undefined = undefined

// eslint-disable-next-line @reatom/unit-naming-rule
export const tradingTransactionsModelAtom = atom((ctx) => {
  const network = ctx.spy(selectedNetworkAtom)
  const walletId = ctx.spy(tradingWalletIdAtom) ?? WalletId('')

  const walletTransactionsModel = (() => {
    const cached = walletCache
    if (!cached || cached.walletId !== walletId) {
      // eslint-disable-next-line @reatom/unit-naming-rule
      const model = reatomUserTransactions({
        network,
        pairAddress: undefined,
        delugeId: undefined,
      })
      walletCache = { walletId, model }
      return model
    }

    return cached.model
  })()

  return walletTransactionsModel
})
